import { useAuth } from '@frontend/context/authContext';
import getClient from './client';

const useClient = () => {
  const { token } = useAuth();
  return getClient({ token });
};

export default useClient;
